import produce from 'immer';
import {
  MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST,
  MARKET_CAR_LOG_INFO_LIST_REQUEST,
  MARKET_GEM_LOG_INFO_LIST_REQUEST,
  MARKET_ITEMS_LOG_INFO_LIST_REQUEST
} from '../../constants/log/marketTransactionLogConstants';

const initialState = {

};

const marketTransactionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MARKET_CAR_LOG_INFO_LIST_REQUEST:
      break;
    case MARKET_CAR_BOX_LOG_INFO_LIST_REQUEST:
      break;
    case MARKET_GEM_LOG_INFO_LIST_REQUEST:
      break;
    case MARKET_ITEMS_LOG_INFO_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default marketTransactionLogReducer;
